import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

const state = {
    page: null,
    magazineId: null,
    pageId: null,
    marketId: null,
};

let uuid = 0;

const numberToAlphabetChar = (zahl) => {
    let buchstaben = "";
    while (zahl > 0) {
        let modulo = (zahl - 1) % 26;
        buchstaben = String.fromCharCode(97 + modulo) + buchstaben; // 97 ist der ASCII-Wert von 'a'
        zahl = Math.floor((zahl - modulo) / 26);
    }
    return buchstaben;
}

const getters = {
    pageSide: (state) => (state.page?.pagePosition % 2 === 0) ? 'left' : 'right',
    isNonFood: (state) => state.page?.magazineTypeName === 'nonfood22',
    fixedPositionProducts: (state) => {
        const product = state.page?.products
        let ppc = {};
        product.forEach((item, index) => {
            ppc[item.placeholderPosition] = (typeof ppc[item.placeholderPosition] === 'undefined') ? 1 : ppc[item.placeholderPosition] + 1;
        });
        product.forEach((item, index) => {
            item.positionTitle = ppc[item.placeholderPosition] > 1 ? item.placeholderPosition + numberToAlphabetChar(item.productPosition) : item.placeholderPosition;
        });
        return product;
    },
    isPageLocked: (state, getters, rootState) => {
        return rootState.user.userData?.isAdmin || rootState.user.userData?.isMarketing ? false : state.page?.lock;
    }
};


const actions = {
    async fetchPage({ commit }, { magazineId, pagePosition, marketId }) {
        uuid++;
        const currentUuid = uuid;
        try {
            const response = await apolloClient.query({
                query: gql`
                    query GetPage($magazineId: Int!, $pagePosition: Int!, $marketId: Int!) {
                        getPage(magazineId: $magazineId, pagePosition: $pagePosition, marketId: $marketId) {
                            projectId
                            pageId
                            magazineId
                            magazineTypeId
                            magazineTypeName
                            magazinePageCount
                            marketId
                            pagePosition
                            lock
                            name
                            pageTemplateId
                            hooks
                            attributes {
                                key
                                value
                            },
                            products {
                                articleNumber
                                productId
                                placeholderId
                                placeholderWidth
                                placeholderHeight
                                productTemplateId
                                productTemplateName
                                placeholderPosition
                                productPosition
                                marketIds
                                teamIcon
                                teamColor
                                isVirtualArticle
                                virtualMagazineId
                                virtualPagePosition
                                virtualMagazineName
                                virtualMarketId
                                virtualMarketName
                                virtualProjektId
                                virtualProjektName
                                virtualOriginalLastChange
                                virtualAccordionIndex
                                productLogos {
                                    name
                                    productJoinProductLogoId
                                    productLogoId
                                    previewSmall
                                    previewMedium
                                    previewLarge
                                    isActive
                                    position
                                    markedForDeletion
                                    dateTimeCreated
                                    dateTimeUpdated
                                }
                                productPictures {
                                    name
                                    productJoinProductPictureId
                                    productPictureId
                                    previewSmall
                                    previewMedium
                                    previewLarge
                                    isActive
                                    position
                                    markedForDeletion
                                    isDefault
                                    dateTimeCreated
                                    dateTimeUpdated
                                    
                                }
                                productCustomFields {
                                    field
                                    value
                                }
                            }
                        }
                    }
                `,
                variables: {
                    magazineId,
                    pagePosition,
                    marketId,
                },
            });


            if(uuid == currentUuid) {
                commit('setPage', response.data.getPage);
                commit('setPageId', response.data.getPage.pageId);
                commit('setMarketId', response.data.getPage.marketId);
                commit('setMagazineId', response.data.getPage.magazineId);
            }


        } catch (error) {
            console.error('Error while fetching page:', error);
        }
    },
    //reload page
    async reloadPage({ dispatch, state }) {
        await dispatch('fetchPage', {
            magazineId: state.magazineId,
            pagePosition: state.page.pagePosition,
            marketId: state.marketId
        });
    },

    //change page template
    async changePageTemplate({}, { pageId, pageTemplateId }) {
        try {
            const response = await apolloClient.mutate({
                mutation: gql`
                    mutation ChangePageTemplate($pageId: Int!, $pageTemplateId: Int!) {
                        changePageTemplate(pageId: $pageId, pageTemplateId: $pageTemplateId) {
                            success
                        }
                    }
                `,
                variables: {
                    pageId,
                    pageTemplateId,
                },
            });

            //await dispatch('reloadPage');
        } catch (error) {
            console.error('Error while changing page template:', error);
        }
    },
};

const mutations = {
    setPage(state, page) {
        state.page = page;
    },
    setPageId(state, pageId) {
        state.pageId = pageId;
    },
    setMarketId(state, marketId) {
        state.marketId = marketId;
    },
    setMagazineId(state, magazineId) {
        state.magazineId = magazineId;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
